module.exports = __webpack_public_path__ + "media/images/prizes__sidebar--image-f359b6bbe8bcda636fd71f7c0accef1f.png";